import {
  AdminEventsList,
  AdminEventCreate,
  AdminVenueList,
  AdminRequestedEventsList,
  AdminListing,
  RedirectToEvents,
  AdminCityList,
} from '.';
import {
  AdminTmtEventsList,
  PrimaryAdminPanel,
  RedirectToEvents as PrimaryRedirectToEvents,
  TmtEventEdit,
  OrganizersList,
  OrganizersEdit,
  AdminFinishedEventsList,
  AdminDeletedEventsList,
  AdminRescheduledEventsList,
  AdminLiveAndUpcomingEventsList,
  AdminCancelledEventsList,
} from './primary-admin-panel';


export default [
  {
    id: 'admin-panel-event-list',
    path: '/admin',
    permission: 'isAdmin',
    layout: AdminListing,
    element: RedirectToEvents,
  },
  {
    id: 'admin-panel-event-list',
    path: '/admin/events',
    permission: 'isAdmin',
    layout: AdminListing,
    element: AdminEventsList,
  },
  {
    id: 'admin-panel-event-list',
    path: '/admin/event/create',
    layout: AdminListing,
    element: AdminEventCreate,
    permission: 'isAdmin',
  },
  {
    id: 'admin-panel-event-list',
    path: '/admin/event/:id',
    layout: AdminListing,
    element: AdminEventCreate,
    permission: 'isAdmin',
  },
  {
    id: 'admin-panel-event-list',
    path: '/admin/requested-events',
    permission: 'isAdmin',
    layout: AdminListing,
    element: AdminRequestedEventsList,
  },
  {
    id: 'admin-panel-event-list',
    path: '/admin/venues',
    permission: 'isAdmin',
    layout: AdminListing,
    element: AdminVenueList,
  },
  {
    id: 'admin-panel-city-list',
    path: '/admin/cities',
    permission: 'isAdmin',
    layout: AdminListing,
    element: AdminCityList,
  },
  {
    id: 'admin-panel-primary-wrapper',
    path: '/admin/primary',
    permission: 'isAdmin',
    layout: PrimaryAdminPanel,
    element: PrimaryRedirectToEvents,
  },
  {
    id: 'admin-panel-primary-event-list',
    path: '/admin/primary/events',
    permission: 'isAdmin',
    layout: PrimaryAdminPanel,
    element: AdminTmtEventsList,
  },
  {
    id: 'admin-panel-primary-event-edit',
    path: '/admin/primary/event/:eventId',
    permission: 'isAdmin',
    layout: PrimaryAdminPanel,
    element: TmtEventEdit,
  },
  {
    id: 'admin-panel-primary-organizers-list',
    path: '/admin/primary/organizers',
    permission: 'isAdmin',
    layout: PrimaryAdminPanel,
    element: OrganizersList,
  },
  {
    id: 'admin-panel-primary-organizers-edit',
    path: '/admin/primary/organizers/:organizerId',
    permission: 'isAdmin',
    layout: PrimaryAdminPanel,
    element: OrganizersEdit,
  },
  {
    id: 'admin-panel-primary-finished-event-list',
    path: '/admin/primary/past',
    permission: 'isAdmin',
    layout: PrimaryAdminPanel,
    element: AdminFinishedEventsList,
  },
  {
    id: 'admin-panel-primary-live-and-upcoming-event-list',
    path: '/admin/primary/live',
    permission: 'isAdmin',
    layout: PrimaryAdminPanel,
    element: AdminLiveAndUpcomingEventsList,
  },
  {
    id: 'admin-panel-primary-deleted-event-list',
    path: '/admin/primary/deleted',
    permission: 'isAdmin',
    layout: PrimaryAdminPanel,
    element: AdminDeletedEventsList,
  },
  {
    id: 'admin-panel-primary-cancelled-event-list',
    path: '/admin/primary/cancelled',
    permission: 'isAdmin',
    layout: PrimaryAdminPanel,
    element: AdminCancelledEventsList,
  },
  {
    id: 'admin-panel-primary-rescheduled-event-list',
    path: '/admin/primary/rescheduled',
    permission: 'isAdmin',
    layout: 'isAdmin',
    layout: PrimaryAdminPanel,
    element: AdminRescheduledEventsList,
  }
];
